
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/guild/interval/[tier]",
      function () {
        return require("private-next-pages/[locale]/guild/interval/[tier]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/guild/interval/[tier]"])
      });
    }
  